import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA2Zf_PqT63dik5jaZyNPvXYNz8V6gdJEg",
  authDomain: "tafcrm-be5e5.firebaseapp.com",
  projectId: "tafcrm-be5e5",
  storageBucket: "tafcrm-be5e5.firebasestorage.app",
  messagingSenderId: "520743650569",
  appId:  "1:520743650569:web:c0ffd8a9b164755b253fd8",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);